var app = angular.module("leonardo");

var GroupList = function($scope, $rootScope, $q, ngDialog, $controller, PropertyGroupService, PermissionService, FilterService) {

  $scope.permissionService = PermissionService;

  $scope.getEntitiesPromise = function(options) {
    options.summary = true;
    var defer = $q.defer();
    if (FilterService.hasFilter('account_reports')) {
      options['account'] = FilterService.getFilter('account_reports');
    }
    if (FilterService.hasFilter('managed_by_reports')) {
      options['managed_by'] = FilterService.getFilter('managed_by_reports');
    }
    if (FilterService.hasFilter('portfolio_reports')) {
      options['portfolio'] = FilterService.getFilter('portfolio_reports');
    }
    if (FilterService.hasFilter('search')) {
      options['search'] = FilterService.getFilter('search');
    }
    if (FilterService.hasFilter('levels')) {
      options['levels'] = FilterService.getFilter('levels');
    }
    PropertyGroupService.getlist(options).then(function(data) {
      $scope.groupGroups(data.results ? data.results : data);
      defer.resolve(data);
    });
    return defer.promise;
  };

  $scope.showGroupEditDialog = function(group) {
    PropertyGroupService.get(group.id).then(function (result) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/group/add.html',
        controller: 'GroupAddDialog',
        data: {
          group: result,
          mode: 'edit',
          account: result.account
        }
      }).then(function() {
        $rootScope.$broadcast('group:updated', group);
      });
    });
  };

  $scope.showGroupDeleteDialog = function(group) {
    PropertyGroupService.get(group.id).then(function (result) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/delete.html',
        controller: 'DeleteDialog',
        data: {
          object: result,
          type: 'group'
        }
      }).then(function() {
        PropertyGroupService.updateCollection(group, true);
        $rootScope.$broadcast('group:deleted', group);
      });
    });
  };

  $scope.indexGroupAccount = function(account) {
    var index = -1;
    angular.forEach($scope.grouped, function(group, key) {
      if (group.account === account) {
        index = key;
      }
    });
    return index;
  };

  $scope.groupGroups = function(results){
    $scope.grouped = [];
    angular.forEach(results, function(data){
      var index = $scope.indexGroupAccount(data.account);
      if(index < 0) {
        $scope.grouped.push({ account: data.account, property_groups: [] });
        index = $scope.grouped.length-1;
      }
      $scope.grouped[index].property_groups.push(data);
    });
  };

  $scope.$on('group:added', function() {
    $scope.loadPage($scope.page);
  });

  $scope.$on('group:deleted', function() {
    $scope.loadPage($scope.page);
  });

  $scope.$on('group:updated', function() {
    $scope.loadPage($scope.page);
  });

  $controller('TableFilterController', {$scope: $scope});

  $scope.loadPage($scope.page);

};

app.controller('GroupList', ['$scope', '$rootScope', '$q', 'ngDialog', '$controller', 'PropertyGroupService',
  'PermissionService', 'FilterService', GroupList]);
